module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-container d-flex justify-center align-center flex-column"
  }, [_c('h3', {
    staticClass: "mb-md-15 mb-8"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.title2) + "\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.title3) + "\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "mt-4 plan_btn",
    attrs: {
      "href": "#plans"
    }
  }, [_vm._v(" Choose a plan ")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-abbaea20","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing3/Banner.vue
// module id = 1835
// module chunks = 180